import styled, { css } from 'styled-components/macro';
import media from 'helpers/media';

interface CardProps {
    noShadow?: boolean;
    smallPadding?: boolean;
    hasOverflow?: boolean;
    mobileCard?: boolean;
    mobileCardFilled?: boolean;
    noPadding?: boolean;
}

const Card = styled.div<CardProps>`
    position: relative;
    padding: ${({ theme }) => theme.space.xlarge};
    background-color: ${({ theme }) => theme.colors.white};
    
    ${({ noShadow }) =>
        !noShadow &&
        css`
            border-radius: 8px;
            box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);
        `}

    ${({ smallPadding, theme }) =>
        smallPadding &&
        css`
            padding: ${theme.space.medium};
        `}

    ${({ hasOverflow }) =>
        !hasOverflow &&
        css`
            overflow: hidden;
        `}


    ${({ mobileCard, mobileCardFilled, theme }) => media.mobile`
        ${
            mobileCard
                ? `padding: ${theme.space.medium};`
                : mobileCardFilled
                ? `padding: ${theme.space.sbase};`
                : `padding: 0; background-color: transparent; box-shadow: none;`
        }
    `}

    ${({ noPadding }) =>
        noPadding &&
        css`
            padding: 0;
            position: static;
        `}
`;

export default Card;
